// extracted by mini-css-extract-plugin
export var border = "_2o-8";
export var brand = "_2o-t";
export var button = "_2o-l";
export var center = "_2o-a";
export var centered = "_2o-6";
export var closeButton = "_2o-c";
export var disabledWrapper = "_2o-m";
export var error = "_2o-p";
export var extraLarge = "_2o-4";
export var extraSmall = "_2o-1";
export var fill = "_2o-i";
export var footer = "_2o-h";
export var footerAction = "_2o-j";
export var footerButtons = "_2o-k";
export var header = "_2o-7";
export var headerWithClose = "_2o-d";
export var icon = "_2o-o";
export var info = "_2o-s";
export var inline = "_2o-9";
export var large = "_2o-3";
export var main = "_2o-e";
export var modal = "_2o-0";
export var nearFull = "_2o-5";
export var neutral = "_2o-u";
export var noPadding = "_2o-g";
export var none = "_2o-v";
export var scrollable = "_2o-f";
export var small = "_2o-2";
export var success = "_2o-r";
export var tight = "_2o-n";
export var titleIcon = "_2o-b";
export var warn = "_2o-q";